import { authHeader, handleResponse } from '../helpers';
export const UserAccountBalanceRptService = {
    fetchUserloyalityLogData   
};

function fetchUserloyalityLogData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}UserLoyalityLogRpt/AccountBalanceReport`, requestOptions)
        .then(handleResponse);
}